import React from 'react';
import { useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';
import { PORTAL_HINWEISE, hinweisFuer } from '../hilfe/hinweise';

const Hinweis = () => {
  const { pathname } = useLocation();
  const text = hinweisFuer(PORTAL_HINWEISE, pathname);
  return text ? <p className="mt-3 inline-flex items-start gap-2 max-w-xl text-[13px] text-white/75 leading-relaxed" data-testid="portal-seitenhinweis"><Info className="w-4 h-4 mt-0.5 shrink-0 text-[#e0b56a]" />{text}</p> : null;
};

export const PortalKopf = ({ kicker, titel, children }) => (
  <section className="relative overflow-hidden bg-[#0B1724] text-white" data-testid="portal-kopf">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.08)_1px,transparent_0)] [background-size:22px_22px]" />
    <div className="pointer-events-none absolute -top-24 -right-20 w-[28rem] h-[28rem] rounded-full bg-[radial-gradient(circle,rgba(42,82,128,0.9),transparent_65%)]" />
    <div className="pointer-events-none absolute -top-28 -left-24 w-[24rem] h-[24rem] rounded-full bg-[radial-gradient(circle,rgba(224,181,106,0.35),transparent_65%)]" />
    <div className="relative max-w-3xl mx-auto px-5 pt-7 pb-8">
      {kicker && <p className="text-[#e0b56a] text-[11px] tracking-[0.3em] uppercase">{kicker}</p>}
      <h1 className="font-serif text-3xl sm:text-4xl mt-1 motion-safe:animate-[fadeIn_.35s_ease-out]">{titel}</h1>
      <Hinweis />
      {children}
    </div>
  </section>
);

export const PortalSeite = ({ children, testId }) => (
  <div className="min-h-screen bg-[#f5f8fa]" data-testid={testId}>{children}</div>
);

export const eur = (v) => (v == null ? '' : Number(v).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }));
export const datum = (iso) => { if (!iso) return ''; try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch { return iso; } };

export default PortalKopf;
